import { IAuthenticationService } from '@my-backoffice/app/shared/auth/authentication.service.interface';
import { InjectionToken } from '@angular/core';

export const AUTHENTICATION_SERVICE = new InjectionToken<IAuthenticationService>('AUTHENTICATION_SERVICE');
